import integrationsService from '@/services/integrations.js'

const state = {
    erpIntegration: null
}

const getters = {
    hasErpIntegration (state) {
        return state.erpIntegration?.hasErpIntegration
    },

    erpIntegration (state) {
        return state.erpIntegration
    },

    mainCurrencyCode (state) {
        return state.erpIntegration?.mainCurrencyCode
    }
}

const mutations = {
    setErpIntegration (state, data) {
        state.erpIntegration = data
    }
}

const actions = {
    async setErpIntegration ({ commit }) {
        let parameters = {
            filter: {
                slug: 'ERP',
                key: 'hasErpIntegration'
            },
        }

        let response = await integrationsService.retrieveAppSettings(parameters)

        let erpIntegrationData = {
            hasErpIntegration: false
        }

        if (response.data.status === 'success' && response.data.results.length) {
            erpIntegrationData.hasErpIntegration = response.data.results[0].value === 'true'
            erpIntegrationData.mainCurrencyCode = 'aoa'
        } 
        
        commit('setErpIntegration', erpIntegrationData)
    },
    
    clearErpIntegration ({ commit }) {
        commit('setErpIntegration', null)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}
